{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/progress';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/ProgressBarAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the accessibility implementation for a progress bar component.';
export const isSubpage = true;

# useProgressBar

<PageDescription>{docs.exports.useProgressBar.description}</PageDescription>

```tsx render files={["starters/hooks/src/ProgressBar.tsx", "starters/hooks/src/ProgressBar.css", "starters/hooks/src/Form.css"]}
"use client";
import {ProgressBar} from 'hooks-starter/ProgressBar';

<ProgressBar label="Loading…" value={80} />
```

## API

<Anatomy />

```tsx
<ProgressBar>
  <Label />
</ProgressBar>
```

<FunctionAPI function={docs.exports.useProgressBar} links={docs.links} />

### AriaProgressBarProps

<InterfaceType {...docs.exports.AriaProgressBarProps} />

### ProgressBarAria

<InterfaceType {...docs.exports.ProgressBarAria} />
